import React, { createContext, useState, useContext, useEffect } from "react";
import calculate from "src/calculator/calculate";
// import { getSpendingItemOverYears } from "src/components/Spending/calculate";
import { Client, Income, ScenarioSettings } from "src/types";

interface CalculatedYear {
  incomes: Record<
    number,
    {
      incomeId: number;
      amount: number;
      note?: string;
    }
  >;
  spending: {
    base: Record<string, number>;
    pre: Record<string, number>;
    post: Record<string, number>;
  };
}

type CalculatedScenario = Record<number, CalculatedYear>;

interface ScenarioContextType {
  scenario: CalculatedScenario;
}

const ScenarioContext = createContext<ScenarioContextType | undefined>(
  undefined,
);

export const ScenarioProvider: React.FC<{
  children: React.ReactNode;
  scenario: ScenarioSettings;
  client: Client;
}> = ({ children, scenario, client }) => {
  const [calculated, setCalculated] = useState<CalculatedScenario>([]);

  useEffect(() => {
    console.log("scc run");
    const divisionFactor =
      client.liveSettings.monthlyYearly === "monthly" ? 12 : 1;
    const results = {} as any;
    const calculateOne = (income: Income, currentYear: number) => {
      const startTime = performance.now();
      const result = calculate({
        people: client.people,
        income,
        currentYear,
        scenario,
      });
      const endTime = performance.now();
      if (results[income.type]) {
        results[income.type].push(endTime - startTime);
      } else {
        results[income.type] = [endTime - startTime];
      }

      return {
        ...result,
        amount: result.amount / divisionFactor,
      };
    };

    // const baseSpending = getSpendingItemOverYears(
    //   client.people,
    //   client.spending,
    //   scenario,
    //   currentYear,
    //   currentYear + scenario.maxYearsShown,
    //   "base",
    // );
    // const preSpending = client.spending.preSpending.map((item) =>
    //   getSpendingItemOverYears(
    //     client.people,
    //     client.spending,
    //     scenario,
    //     currentYear,
    //     currentYear + scenario.maxYearsShown,
    //     "pre",
    //     item.category,
    //   ),
    // );
    //
    // const postSpending = client.spending.postSpending.map((item) =>
    //   getSpendingItemOverYears(
    //     client.people,
    //     client.spending,
    //     scenario,
    //     currentYear,
    //     currentYear + scenario.maxYearsShown,
    //     "post",
    //     item.category,
    //   ),
    // );

    const calculateScenario = (): CalculatedScenario => {
      const currentYear = new Date().getFullYear();
      const years: CalculatedScenario = {};
      const startTime = performance.now();
      for (let i = 0; i < 50; i++) {
        const year = currentYear + i;
        years[year] = {
          incomes: Object.fromEntries(
            scenario.incomes
              .filter((i) => i.enabled)
              .map((i) => [
                i.id,
                {
                  incomeId: i.id,
                  ...calculateOne(i, year),
                },
              ]),
          ),
          spending: {
            /* base: {
              name: baseSpending[year].amount,
            },
            pre: preSpending.reduce((acc, item) => {
              return { ...acc, ...item[year] };
            }, {}),
            post: postSpending.reduce((acc, item) => {
              return { ...acc, ...item[year] };
            }, {}),*/
          } as any,
        };
      }
      const endTime = performance.now();
      console.log(
        Object.keys(results).map(
          (key) =>
            `${key}: ${results[key].reduce((a: any, b: any) => a + b, 0) / results[key].length}ms ${results[key].length} ${results[key].reduce((a: any, b: any) => a + b, 0)}`,
        ),
        `Total time: ${(endTime - startTime).toFixed(2)}ms`,
      );
      return years;
    };

    console.time("scc start");
    const result = calculateScenario();
    console.timeEnd("scc start");
    setCalculated(result);
  }, [scenario]);

  return (
    <ScenarioContext.Provider value={{ scenario: calculated }}>
      {children}
    </ScenarioContext.Provider>
  );
};

export const useScenario = () => {
  const context = useContext(ScenarioContext);
  if (context === undefined) {
    throw new Error("useScenario must be used within a ScenarioProvider");
  }
  return context;
};
